import {
  AbstractControl,
  ValidationErrors,
  AsyncValidatorFn,
  ValidatorFn,
} from '@angular/forms';
import { map, take} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import { UserAdminService } from '@services/user-admin.service';

export function uniqueEmailValidator(email: string, service: UserAdminService): AsyncValidatorFn  {

  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    return service.validateUserEmail(control.value).pipe(
      map((isValid) => {
        if(email) {
          if(email == control.value) {
            return null;
          }
        }
        return (isValid ? {uniqueEmail: true} : null );
      }),take(1)
    );
  };
}

export function emailLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const [localPart, domainPart] = control.value.split("@");

    if (localPart && localPart.length > 64) {
      return { emailLength: true };
    }
    if (domainPart && domainPart.length > 64) {
      return { emailLength: true };
    }
    if (control.value.length > 100) { 
      return { emailLength: true };
    }

    return null;
  };
}